import type {CustomerStoriesV2SliceReskinPrimary} from 'prismicio-types'
import {useState} from 'react'
import {Slide} from 'slices/CustomerStoriesV2/Autoplay/Slide'
import {resolveCardFromDocument} from 'slices/CustomerStoriesV2/resolveCardFromDocument'
import {Container} from 'src/common/Container'
import SwiperNavButtons from 'src/common/SwiperNavButtons'
import type {Context} from 'src/common/types'
import {Pagination} from 'swiper/modules'
import type {SwiperClass} from 'swiper/react'
import {Swiper, SwiperSlide} from 'swiper/react'

type DefaultCustomerStoriesV2ReskinProps = {
  slice: {
    primary: CustomerStoriesV2SliceReskinPrimary
    slice_type: string
    variation: string
  }
  pageUid: string
  componentIndex: number
  context: Context
}

/**
 * Component for "CustomerStoriesV2" Slices.
 */
export const ReskinCustomerStoriesV2 = ({
  slice: {primary},
  slice,
  context,
  componentIndex,
}: DefaultCustomerStoriesV2ReskinProps): JSX.Element => {
  const [swiperInstance, setSwiperInstance] = useState<SwiperClass | null>(null)
  const [activeIndex, setActiveIndex] = useState<number>(0)

  return (
    <Container
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      backgroundColor={slice.primary.background_color || 'Moss White'}
      className="w-full"
    >
      <div className="grid w-full max-w-[1200px] scroll-mt-16 grid-cols-4 px-5 md:gap-12 xl:px-0">
        <div className="col-span-4 mb-12 flex items-end justify-between gap-6 max-md:mb-6 max-md:flex-col max-md:items-start md:mb-0">
          <h3 className="text-24 font-medium leading-8 text-moss-black lg:text-32">{primary.title}</h3>
          <SwiperNavButtons swiperInstance={swiperInstance} key={activeIndex} enableReskin />
        </div>
        <Swiper
          className="col-span-4 max-w-full !overflow-visible md:w-full"
          modules={[Pagination]}
          onActiveIndexChange={(swiper) => setActiveIndex(swiper.activeIndex)}
          spaceBetween={24}
          slidesPerView="auto"
          onSwiper={(swiper) => setSwiperInstance(swiper)}
          wrapperClass="ease-in-out duration-100"
        >
          {primary.customer_stories.map((card, index) => (
            <SwiperSlide className="w-full max-w-[1200px] rounded-lg bg-green-dark md:!h-[448px]" key={index}>
              <Slide
                card={{...resolveCardFromDocument(card)}}
                buttonLabel={primary.button_label ?? undefined}
                index={index}
                componentIndex={componentIndex}
                pageUid={context.pageUid}
                enableReskin
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </Container>
  )
}
